var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTagDarkDuskFaded = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5247 2.5944C19.4907 1.54042 18.6442 0.693922 17.5903 0.659923L10.7402 0.438952C10.1876 0.421128 9.65236 0.632798 9.26146 1.0237L1.52446 8.7607C0.743411 9.54174 0.74341 10.8081 1.52446 11.5891L8.59553 18.6602C9.37658 19.4412 10.6429 19.4412 11.424 18.6602L19.161 10.9232C19.5519 10.5323 19.7635 9.99703 19.7457 9.4445L19.5247 2.5944ZM17.5258 2.65888L17.7467 9.50898L10.0097 17.246L2.93867 10.1749L10.6757 2.43791L17.5258 2.65888ZM11.424 8.7607C12.205 9.54175 13.4713 9.54174 14.2524 8.7607C15.0334 7.97965 15.0334 6.71332 14.2524 5.93227C13.4713 5.15122 12.205 5.15122 11.424 5.93227C10.6429 6.71332 10.6429 7.97965 11.424 8.7607Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTagDarkDuskFaded);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tag-dark-dusk-faded.5e03b76ddfa9af452dafb912ccf85bdd.svg";